import { FC, ReactNode } from 'react';

import bulletIcon from 'assets/images/tick.svg';

import S from './BulletsLabeled.Styled';

interface BulletItemProps {
  text: ReactNode;
  number?: number;
  showOrder?: boolean;
}

export const BulletItem: FC<BulletItemProps> = ({ text, number, showOrder }) => (
  <>
    {!showOrder && <S.BulletIcon src={bulletIcon} />}
    {showOrder && <S.OrderIndicator>{number}</S.OrderIndicator>}
    <S.BulletText>{text}</S.BulletText>
  </>
);

export interface BulletsSection {
  title: string;
  bullets: ReactNode[];
}

interface Props {
  sections: BulletsSection[];
  showOrder?: boolean;
}

export const BulletsLabeled: FC<Props> = ({ sections, showOrder }) => (
  <S.BulletsListContainer>
    {sections.map((section) => (
      <S.SectionContainer key={section.title}>
        <S.Title>{section.title}</S.Title>
        {section.bullets.map((bullet, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <BulletItem key={index} text={bullet} number={index + 1} showOrder={showOrder} />
        ))}
      </S.SectionContainer>
    ))}
  </S.BulletsListContainer>
);
